import { NgModule } from '@angular/core';
import { OptionModuleInReply } from '../../../../reply';
import { OptionNumberComponent } from './option-number.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [OptionModuleInReply, FormsModule],
  declarations: [OptionNumberComponent],
  exports: [OptionNumberComponent]
})
export class OptionNumberModule {}
